(() => {
  const update = () => document.querySelectorAll('[data-bhq-preorder]').forEach(root => {
    const cutoff = Date.parse(root.dataset.cutoff);
    if (!Number.isFinite(cutoff)) return;
    const remaining = cutoff - Date.now();
    const closed = remaining <= 0;
    root.querySelector('[data-bhq-preorder-badge]').textContent = closed ? root.dataset.closed : root.dataset.open;
    root.querySelector('[data-bhq-preorder-copy]').textContent = closed ? root.dataset.closedCopy : root.dataset.openCopy;
    root.querySelector('[data-bhq-preorder-timer-wrap]').hidden = closed;
    root.querySelector('[data-bhq-preorder-cta]').hidden = closed;
    if (closed) return;
    const totalMinutes = Math.ceil(remaining / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    root.querySelector('[data-bhq-preorder-timer]').textContent = days + ' ' + root.dataset.days + ' · ' + hours + ' ' + root.dataset.hours + ' · ' + minutes + ' ' + root.dataset.minutes;
  });
  update();
  setInterval(update, 30000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
